<template>
    <async-wrapper
        :data="orderTransactionResults"
        :loading="async.loading && orderTransactionResults.length <= 0"
        :error="async.error"
        :wrapperClass="'d-flex flex-column justify-content-center align-items-center'"
    >
        <template slot="dataComponent">
            <order-transactions-card :orderTransactions="orderTransactionResults"></order-transactions-card>
        </template>
        <template slot="loadingComponent">
            <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>
        </template>
        <template slot="errorComponent">
            <p>{{ async.error }}</p>
        </template>
        <template slot="emptyComponent">
            <p>No Transactions found for this order</p>
        </template>
    </async-wrapper>
</template>

<script>
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
import OrderTransactionsCard from 'Shared/Cards/OrderTransactionsCard'
export default {
    components: {
        AsyncWrapper,
        OrderTransactionsCard
    },
    data() {
        return {
            orderId: this.$route.params.id
        }
    },
    computed: {
        orderTransactionResults() {
            return this.$store.getters['orderTransactions/GET_ORDER_TRANSACTIONS']
        },
        async() {
            return this.$store.getters['orderTransactions/GET_ASYNC']
        }
    },
    created() {
        this.$store.dispatch('orderTransactions/FETCH_ORDER_TRANSACTIONS_BY_ORDER_ID', {
            id: this.orderId
        })
    },
    beforeDestroy() {
        this.$store.dispatch('orderTransactions/REMOVE_ORDER_TRANSACTIONS_REFERENCE', {
            id: this.orderId
        })
    }
}
</script>
